import NavBar from '../../components/Header/NavBar/NavBar';
import ContactFooter from './ContactFooter/ContactFooter';
import { useState } from 'react';
import Divider from '../../components/Divider/Divider';
import Modal from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';

const Footer = () => {
  const [isRequestSent, setIsRequestSent] = useState(false);
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <footer className='footer'>
        <Divider />
        <div className='footer__container'>
          <NavBar
            source='footer'
            className='footer'
            isOpen={isOpen}
            setOpen={setOpen}
          />
          <ContactFooter
            setIsRequestSent={setIsRequestSent}
            className='footer__connection contact'
          />
          <div className='footer__copy text-micro'>
            &copy; ContactPay. 2020-2023
          </div>
        </div>
      </footer>
      {isRequestSent && (
        <Modal
          isOpen={isRequestSent}
          onClose={() => setIsRequestSent(false)}
          className='thank-popup popup'
          title='Thank you!'
        >
          <p className='popup__text text-large '>
            Your request has been successfully sent.
          </p>
          <p className='popup__text text-large '>
            Our expert will contact you soon.
          </p>
          <Button
            className='popup__button'
            type='button'
            onClick={() => setIsRequestSent(false)}
          >
            Close
          </Button>
        </Modal>
      )}
    </>
  );
};
export default Footer;
